import { MetadataOptions } from "sap/ui/base/ManagedObject";
import {
  ManyOptionsComboBoxMetadata,
  ManyOptionsComboBoxFilterOptions,
  ManyOptionsComboBoxUpdateItems,
} from "../utils/ManyOptionsComboBoxUtil";
import MultiComboBox from "sap/m/MultiComboBox";

/**
 * @namespace akademika.akamont.customControls
 */
export default class ManyOptionsMultiComboBox extends MultiComboBox {
  static readonly metadata: MetadataOptions = ManyOptionsComboBoxMetadata;

  static renderer = { apiVersion: 2 };

  updateItems(sReason: string) {
    // @ts-expect-error Method "updateItems" exists, but isn't exposed through the type
    super.updateItems.apply(this, [sReason]);

    ManyOptionsComboBoxUpdateItems(this, sReason);
  }

  public oninput(oEvent: unknown) {
    ManyOptionsComboBoxFilterOptions(this);
    // @ts-expect-error Method "ComboBox.oninput" exists, but isn't exposed through the type
    super.oninput(oEvent);
  }
}
